import { useContext, useEffect, useState } from "react"
import { useNavigate } from "react-router-dom"
import utility from "src/utils/utility"
import ApiContext from "src/provider/API/call-service"
import AppInfoContext from "src/provider/state-manager/appInfoProvider"
import { AppSpan, AppText, CustomContainer, FlexRow, PageTitle, PageWrapper } from "src/style"
import { IoIosArrowBack } from "react-icons/io"
import { billingDetailsServiceColumns, billingDetailsServiceData } from 'src/utils/table-layout'
import { Table } from "src/component"
import helpers from "src/utils/helpers"

const BillingDetails = () => {
    const navigate = useNavigate()
    const { API } = useContext(ApiContext)
    const { info: {selectedBilling} } = useContext(AppInfoContext)
    const [report, setReport] = useState<Array<any>|null>(null)
    const [billingDetails, setBillingDetails] = useState(selectedBilling)

    useEffect(() => {
        handleFetchReport()
    }, [])

    useEffect(() => {
        if (selectedBilling) setBillingDetails(selectedBilling)
    }, [billingDetails])

    async function handleFetchReport () {
        
        const response = helpers.addSerialNumberNonPagination(billingDetailsServiceData)

        if (response) {
            setReport(response)
        }
    }

    return (
        <>
            <PageWrapper>
                <FlexRow 
                    width="auto" sizeUnit="" gap="1"
                    onClick={() => navigate(-1)}
                >
                    <AppSpan textSize='2.5' cursor='pointer' bottomMargin='1' >
                        <IoIosArrowBack />
                    </AppSpan>
                    
                    <PageTitle 
                        color='#101828' textSize='3' fontWeight="500"
                    >
                        Billing History Details
                    </PageTitle>
                </FlexRow>
                <CustomContainer topMargin="2.5">
                    <CustomContainer>
                        <AppText textSize="1.7" fontWeight="500" color="#101828">{billingDetails?.billingName}</AppText>
                        <FlexRow 
                            gap="4" alignItems="flex-start"
                            padding="2.5" minHeight="10.6"
                            radius="0.8" borderColor="#EAECF0"
                            shadow='0px 1px 2px 0px #1018280F'
                            topMargin="1.5" bottomMargin="1"
                            wrap="wrap"
                        >
                            <CustomContainer width="30">
                                <AppText 
                                    textSize="1.5" fontWeight="500" 
                                    color="#333542" bottomMargin="0.7"
                                >
                                    Period
                                </AppText>
                                <AppSpan fontWeight="300" color="#333542">
                                    {billingDetails?.dateCreated ? helpers.splitDateTime(billingDetails?.dateCreated)?.completeDateTime : null}
                                </AppSpan>
                            </CustomContainer>
                            <CustomContainer width="30">
                                <AppText 
                                    textSize="1.5" fontWeight="500" 
                                    color="#333542" bottomMargin="0.7"
                                >
                                    Total Charges
                                </AppText>
                                <AppSpan fontWeight="300" color="#333542">
                                    N{utility.koboFormat(billingDetails?.amount || 0)}
                                </AppSpan>
                            </CustomContainer>
                            <CustomContainer width="30">
                                <AppText 
                                    textSize="1.5" fontWeight="500" 
                                    color="#333542" bottomMargin="0.7"
                                >
                                    Number of Services
                                </AppText>
                                <AppSpan fontWeight="300" color="#333542">
                                    {billingDetails?.numberOfServices}
                                </AppSpan>
                            </CustomContainer>
                        </FlexRow>
                    </CustomContainer>
                    <Table 
                        tableData={report}
                        tableColumns={billingDetailsServiceColumns} 
                        shouldPaginate={false}
                        customStyle
                    />
                </CustomContainer>
            </PageWrapper>
        </>
    )
}

export default utility.routeData('billing/billing-details', 'Billing Detalils', <BillingDetails/>)